import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit'

import { DocumentType } from '../../models/DocumentType'

import { RootState } from '../store'

interface DocumentTypesState {
  isLoading: boolean
  documentTypes: EntityState<DocumentType, string>
}

const documentTypesAdapter = createEntityAdapter<DocumentType>()

const initialState: DocumentTypesState = {
  isLoading: true,
  documentTypes: documentTypesAdapter.getInitialState(),
}

export const documentTypeSlice = createSlice({
  name: 'documentTypes',
  initialState,
  reducers: {
    setDocumentTypesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setDocumentTypes: (state, action: PayloadAction<DocumentType[]>) => {
      documentTypesAdapter.setAll(state.documentTypes, action.payload)
    },
    resetDocumentTypes: () => initialState,
  },
})

export const { setDocumentTypesLoading, setDocumentTypes, resetDocumentTypes } = documentTypeSlice.actions

const documentTypeSelectors = documentTypesAdapter.getSelectors((state: RootState) => state.processDocument.documentTypes.documentTypes)

export const selectDocumentTypes = (state: RootState) => documentTypeSelectors.selectAll(state)

export const selectDocumentTypesLoading = (state: RootState) => state.processDocument.documentTypes.isLoading
